var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%",
      "showClose": false,
      "closeModel": false
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-logo.png`),
      "alt": "",
      "height": "40"
    }
  }), _vm._v(" + "), _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/tap.png`),
      "alt": "",
      "width": "40"
    }
  })]), _c('div', {
    staticClass: "pop__intro",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-confirm",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.confirmFn
    }
  }, [_vm._v(_vm._s(_vm.btnConfirmText))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };